module.exports = __webpack_public_path__ + "img/bg@2x.6c0c7591.png";